<template>
  <div class="find_select_tab" style="position : fixed;z-index:999999">
    <div class="find-tab-box item-line">
      <div class="item pll30"  :class="currentTab=='1'?'on':''" :data-current="1"  @click="tabNav($event)">
        <span >{{category_name}}</span>
        <i></i>
      </div>
      <div class="item pll60" :class="currentTab=='2'?'on':''" :data-current="2" @click="tabNav($event)">
        <span >{{brand_name.brandName == undefined ? "品牌" : brand_name.brandName}}</span>
        <i></i>
      </div>
      <div class="item pll60" :class="currentTab=='3'?'on':''" :data-current="3" @click="tabNav($event)">
        <span>{{sort_text.text}}</span><i style="left: 90%;"></i>
      </div>
      <div class="item item-end" :class="currentTab=='4'?'on':''" :data-current="4" @click="tabNav($event)">
        <van-dropdown-menu  :overlay="false">
          <van-dropdown-item :title="fliter_name">
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
    </div>
    <div class="tab-content">
      <!-- 分类 -->
      <div v-if="currentTab=='1'">
        <van-tree-select 
          :items="categoryList"
          :active-id.sync="activeIds"
          @click-item="itemId"
          @click-nav="firstIndex"
          :main-active-index.sync="activeIndex">
        </van-tree-select>
        <div class="reset">
            <span @click.stop="type_reset">重置</span>
            <span @click.stop="type_confim">确定</span>
          </div>
      </div>
      <!-- 品牌 -->
      <div v-if="currentTab=='2'">
        <van-index-bar :index-list="brand_list"  highlight-color="#FFD133FF">
          <div class="brand_first" v-for="(item,pindex) in brandList" :key="pindex">
            <van-index-anchor :index="item.initials"/>
              <van-cell 
                v-for="(child,cindex) in item.children" :key="cindex"
                :class="child.isSelected ? 'selected' : ''"
                @click="selectedbrand(pindex,cindex)" 
                :title="child.englishName+'\xa0\xa0\xa0'+child.brandName">
                <img :src="child.logo" alt="">
              </van-cell>
          </div>
        </van-index-bar>
        <div class="reset">
          <span @click.stop="brand_reset">重置</span>
          <span @click.stop="brand_confim">确定</span>
        </div>
      </div>
        <Sort 
          :list.sync="sortList" 
          @selectedEvent="sortFilter" 
          v-if="currentTab=='3'"/>
          <!-- 过滤 -->
        <Fliter 
          :price_list.sync="price_list" 
          :people_list.sync="people_list" 
          :change_list.sync="change_list" 
          @selectprice="selectprice"
          @selectpeople="selectpeople"
          @selectchange="selectchange"
          @fliter_reset="fliter_reset"
          @fliter_confim="fliter_confim" 
          v-if="currentTab=='4'"/>
        <shade @click="ph_close" :display.sync="isCover" @tap="close"></shade>
    </div>
  </div>
</template>
<script>
import Shade from "@/components/common/Shade"
import Sort from "@/components/common/Sort"
import Fliter from "@/components/common/Fliter"
import {getBrandsLists,
getGoodsDicts} from "@/api/category"
export default {
  name: 'findselecttab',
  components: { Shade,Sort,Fliter  },
  data(){
    return{
      activeIds : 0,
      activeIndex :0,
      currentTab : 0,
      scrolled : 0,
      height : 0,
      isCover : false,
      isfixed : false,
      category_name:'分类',
      navArr : [],
      cateArr:[],
      navIndex : 0,
      fristId:'',
      secondId : '',
      brand_list:'',
      brand_name : {"brandName":'品牌'},
      brandId : {secondaryCategory : 0},
      brand_current:'',
      sort_text:{text : "排序"},
      value1 : 0,
      brandList:[],
      fliter_name:'筛选',
      priceIndex:'',
      peopleIndex:'',
      changeIndex:'',
      criteria : {
        queryWords : '',
        usersId : '',
        isSelf : 1,
        isRecommend : '',
        isNew : 1,
        categoryId_first: '',
        categoryId_second :'',
        brandsId : '',
        sort :'',
        prices : '',
        renqunType :'',
        colorId :'',
        pageSize : 10,
        currentPage : 1,
      }
    }
  },
  computed:{
    categoryList(){
      let list = this.$store.getters.categoryList;
      if(!list){
        this.$store.dispatch('getBaseData')
      }
      for(let i=0;i<list.length;i++){
        this.$set(list[i],'isSelected',false)
        for(let a=0;a<list[i].children.length;a++){
          let nk = list[i].children[a]
          this.$set(nk,"isSelected",false)
        }
      }
      return list;
    },
    sortList(){
      let list = this.$store.getters.sortList;
      if(!list){
        this.$store.dispatch('getBaseData')
      }
      return list;
    },
    price_list(){
      let price = this.$store.getters.priceList;
      if(!price){
        this.$store.dispatch('getBaseData')
      } 
      price.forEach(item=>{
        this.$set(item,"isSelected",false)
      })
      return price
    },
    people_list(){
      let people = this.$store.getters.peopleList;
      if(!people){
        this.$store.dispatch('getBaseData')
      }
      people.forEach(item=>{
        this.$set(item,"isSelected",false)
      })
      return people
    },
    change_list(){
      let change = this.$store.getters.changeList;
      if(!change){
        this.$store.dispatch('getBaseData')
      }
      change.forEach(item=>{
        this.$set(item,"isSelected",false)
      })
      return change
    },
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener("scroll",this.onScroll)
    })
    this.brands()
    getGoodsDicts().then(res=>{
      console.log(res)
    }).catch(err=>{
      console.log(err)
    })
    console.log(this.categoryList)
    console.log(this.sortList)
    console.log(this.price_list)
  },
  methods:{
    // onScroll(){
    //   this.scrolled = document.documentElement.scrollTop || document.body.scrollTop
    //   this.height = document.getElementsByClassName('item-line')[0].offsetHeight
    //   if(this.scrolled > this.height){
    //     this.isfixed = true
    //   }else{
    //     this.isfixed = false
    //   }
    // },
    //点击
    tabNav (e) {  
      console.log('111')
      if(this.scrolled > this.height){
        document.getElementsByTagName("body")[0].id="body-touch";
      }
      else{
        // document.body.removeAttribute("class","van-overflow-hidden");
        document.getElementsByTagName("body")[0].id="body-touchmove"
      }
      this.isfixed = true
      this.isCover = true;
      let cur = e.currentTarget.dataset.current;
      if(this.currentTab != cur) {
        this.currentTab = cur;
      } else {
        this.close();
      }
    },
    close () { //关闭层
      this.isCover = false;
      this.currentTab = 0;
      this.isfixed = false
      document.body.removeAttribute("id","body-touchmove");
      document.body.removeAttribute("id","body-touch");
    },
    ph_close(){
      console.log('111')
      this.close()
    },
    //分类
    firstIndex(index){
      this.navIndex = index
      this.activeIds = index
      this.fristId = this.categoryList[index].fatherId
      this.secondId = ''
      this.category_name = this.categoryList[index].text
    },
    itemId(data){
      this.secondId = data.id
      this.activeIds = data.id
      this.category_name = data.text
      console.log(data)
    },
    type_reset(){
      this.category_name = '分类'
      this.activeIds = 0
      this.activeIndex = 0
      this.categoryId_first = ''
      this.categoryId_second = ''
      this.navIndex = ''
      this.secondId = ''
      console.log(this.navIndex)
      this.brandId.secondaryCategory = 0
      this.brands()
      this.$emit('filterEvent', this.criteria);
      console.log(this.criteria)
    },
    type_confim(i){
      console.log(this.navIndex)
      if(this.navIndex == 0){
        this.criteria.categoryId_first = ''
      }else{
        this.criteria.categoryId_first = this.categoryList[this.navIndex].fatherId
      }
      if(this.secondId == 0 || this.secondId == 1 || this.secondId == 2 || this.secondId == 3 || this.secondId == 4 || this.secondId == 5 || this.secondId == 6 || this.secondId == 7){
        this.criteria.categoryId_second = ''
        this.brandId.secondaryCategory == 0
      }else{
        this.criteria.categoryId_second = this.secondId
        this.brandId.secondaryCategory = this.secondId
        this.brands()
      }
      console.log(this.brandId)
      this.close()
      this.$emit('filterEvent', this.criteria);
    },
    //品牌
    brands(){
      let list = this.$store.getters.brandList;
      this.$store.dispatch("getBrandList",this.brandId)
      let arr = []
      for(let i=0;i<list.length;i++){
        arr.push(list[i].initials)
      }
      list.forEach(item=>{
        item.children.forEach(child=>{
          this.$set(child,"isSelected",false)
        })
      })
      this.brand_list = arr
      this.brandList = list
    },
    selectedbrand(pi,ci){
      this.brandList.forEach(item=>{
        item.children.forEach(child=>{
          child.isSelected = false
        })
      })
      this.brandList[pi].children[ci].isSelected = true
      this.brand_name=this.brandList[pi].children[ci]
    },
    brand_reset(){
      this.brandList.forEach(item=>{
        item.children.forEach(child=>{
          child.isSelected = false
        })
      })
      this.brand_name.brandName="品牌"
      this.criteria.brandsId = ''
      this.$emit('filterEvent', this.criteria);
    },
    brand_confim(){
      this.close()
      this.brandList.forEach(item=>{
        item.children.forEach(child=>{
          if(child.isSelected == true){
            this.criteria.brandsId = child.brandId
          }
        })
      })
      this.$emit('filterEvent', this.criteria);
      console.log(this.criteria)
    },
    //排序
    sortFilter(i){
      this.sortList.forEach(item => {
        console.log(item)
        item.isSelected = false
      });
      this.sortList[i].isSelected = true
      this.sort_text = this.sortList[i]
      this.criteria.sort = this.sortList[i].id
      this.close()
      this.$emit('filterEvent', this.criteria);
    },
    selectprice(i){
      this.price_list.forEach(item=>{
        item.isSelected = false
      })
      this.price_list[i].isSelected = true
      console.log(this.price_list[i].id)
    },
    selectpeople(i){
      this.people_list.forEach(item=>{
        item.isSelected = false
      })
      this.people_list[i].isSelected = true
    },
    selectchange(i){
      this.change_list.forEach(item=>{
        item.isSelected = false
      })
      this.change_list[i].isSelected = true
    },
    //筛选
    fliter_reset(){
      this.price_list.forEach(price=>{
        price.isSelected = false
      })
      this.people_list.forEach(people=>{
        people.isSelected = false
      })
      this.change_list.forEach(change=>{
        change.isSelected = false
      })
      this.criteria.prices= ''
      this.criteria.renqunType= ''
      this.criteria.colorId= ''
      this.$emit('filterEvent', this.criteria);
      console.log(this.criteria)
    },
    fliter_confim(){
      this.close()
      for(let i = 0;i<this.price_list.length;i++){
        if(this.price_list[i].isSelected == true){
          this.criteria.prices= this.price_list[i].id
        }
      }
      for(let i = 0;i<this.people_list.length;i++){
        if(this.people_list[i].isSelected == true){
          this.criteria.renqunType= this.people_list[i].id
        }
      }
      for(let i = 0;i<this.change_list.length;i++){
        if(this.change_list[i].isSelected == true){
          this.criteria.colorId= this.change_list[i].id
        }
      }
      this.$emit('filterEvent', this.criteria);
    }
  }
}
</script>
<style lang="less">
.van-dropdown-menu{
  height: 45px !important;
}
.van-index-anchor{
  background:rgb(247,247,247);
}
.find_select_tab {
  width: 100%;
  position: relative;
  background: #fff;
}
.find-tab-box {
  width: 100%;
  height:1.2rem;
  line-height: 1.2rem;
  background-color:#fff;
  justify-content: space-between;
  display: flex;
  z-index: 1001;
  .item {
    font-size: .32rem;
    width: 25%;
    color:#282828FF;
    border-bottom: 0;
    text-align: center;
    position: relative;
    border: none;
    span{
      font-size: .4rem;
      width: 80%;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-left: .2rem;
    }
    .tab {
      line-height: .6rem;
      overflow:hidden;
    }
  }
  .item i {
    position: absolute;
    bottom: 36%;
    left: 82%;
    border: 8px solid #CCCCCCFF;
    border-top-color: #CCCCCCFF;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
  }
  .item:nth-child(2){
    i{
      left: 90%;
    }
    span{
      display: block;
      width: 88%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .item-end {
    padding-right: .26rem;
  }
  .f-icon {
    font-size: 30px;
    color: #333;
  }
  .on, .on .f-icon  {
    color: #FFD133FF;
  }
  .on i {
    bottom: 47%;
    border: 8px solid #FFD133FF;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    color: #FFD133FF !important;
  }
}
.tab-content {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1000;
  left: 0;
  animation: displays 1s;
}
.screen{
  border: none !important;
  bottom: 37% !important;
  color: black !important;
  left: 64% !important;
}
.fixed{
  width: 100%;
  position: fixed;
  top:0;
  left: 0;
  z-index: 1;
}
#body-touchmove {
  position:fixed;
  top:0;
  height: 100%;
  width: 100vh;
  left: 0;
}
#body-touch{
  position: fixed;
  font-size: 36px;
  top: -6rem;
  width: 100%;
}
.van-sidebar-item--select{
  border: none !important;
  font-weight: normal !important;
  color: #FFD133FF !important;
}
.van-tree-select__item--active{
  color: #FFD133FF !important;
}
.van-icon-checked:before{
  content : '' !important;
  width: 20px;
  height: 19px;
  background: url(../../assets/picture/success_yellow.png);
}
.van-sidebar-item--select, .van-sidebar-item--select:active {
  background: #fafafa;
}
.ph_category{
  top: 60%;
}
.reset{
  width: 100%;
  height: 90px;
  background: white;
  position: fixed;
  left: 0;
  color: black;
  z-index: 2222;
  span{
    display: block;
    width: 50% !important;
    height: 100%;
    font-size: 28px;
    float: left;
    line-height: 90px;
    text-align: center;
    padding: 0 0 !important;
  }
  span:nth-child(2){
    background: #FFD133FF;
  }
}
.van-dropdown-item--down{
  top: 5% !important;
  background: white;
}
.van-index-bar{
  height: 65vh;
  overflow-y: auto;
  background: rgb(247,247,247);
}
.van-cell__title{
  position: absolute;
  top: 30%;
  left: 22%;
}
.van-cell__value{
  img{
    width: 1.5rem;
    position: relative;
    top: 23%;
  }
}
.selected{
  position: relative;
  color: #FFD133FF !important;
}
.selected:after{
  position: absolute;
  content: '';
  width: 35px ;
  height: 25px ;
  background: url(../../assets/picture/success_yellow.png) ;
  background-size: 100% ;
  left: 85% !important;
  top: 26%;
  transform: none !important;
  border: none !important;
}
.van-dropdown-menu__title::after{
  top: 48%;
  left: 90%;
  border: 0.107rem solid #CCCCCCFF;
  border-top-color: #CCCCCCFF;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  transform: none;
  top: 71%;
  right: 0;
}
.van-ellipsis{
  text-align: left;
}
.van-index-bar__sidebar{
  top:38%;
}
.item-end{
  .van-dropdown-menu__title::after{
    width: .32rem;
    height: .32rem;
    background: url(../../assets/picture/fliter.jpeg);
    background-size: 100%;
    border: none;
    left: 70%;
    top: 40%;
  }
}
</style>